import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { usePatientsContext } from "context/patient_context";
import editPatientProfile from "api/editPatientProfile";

const useEditPatientProfile = () => {
  const navigate = useNavigate();
  const { handleOpenSnackbar } = usePatientsContext();
  const mutateReminder = useMutation({
    mutationFn: editPatientProfile,
    onSuccess: (res) => {
      if (res.status === 200) {
        handleOpenSnackbar('اطلاعات با موفقیت ثبت شد');
        setTimeout(() => {
          navigate(-1);
        }, 2000);
      }
    },
    onError: (error) => {
      handleOpenSnackbar(error.response.data.messages, 'error');
    }
  });
  return mutateReminder;
};

export default useEditPatientProfile;